export interface BrandingPalette {
  primary: string;
  accent: string;
  surface: string;
  text: string;
}

export interface BrandingTypography {
  fontFamily: string;
  headingWeight: number;
  bodyWeight: number;
}

export interface BrandingSettings {
  palette: BrandingPalette;
  typography: BrandingTypography;
  borderRadius: number;
  logoUrl?: string | null;
}

export interface BrandingTheme {
  id: string;
  teamId: string;
  name: string;
  settings: BrandingSettings;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export const DEFAULT_BRANDING_SETTINGS: BrandingSettings = {
  palette: {
    primary: "#2563eb",
    accent: "#10b981",
    surface: "#ffffff",
    text: "#0f172a",
  },
  typography: {
    fontFamily: "Inter, 'Segoe UI', sans-serif",
    headingWeight: 600,
    bodyWeight: 400,
  },
  borderRadius: 12,
  logoUrl: null,
};

export function mergeBrandingSettings(
  base: BrandingSettings,
  overrides: Partial<BrandingSettings> | null | undefined
): BrandingSettings {
  if (!overrides) {
    return base;
  }
  return {
    palette: {
      ...base.palette,
      ...(overrides.palette ?? {}),
    },
    typography: {
      ...base.typography,
      ...(overrides.typography ?? {}),
    },
    borderRadius: overrides.borderRadius ?? base.borderRadius,
    logoUrl: overrides.logoUrl ?? base.logoUrl ?? null,
  };
}
